import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchCertificate } from '../../actions/profile';
import __ from '../../helpers/translation';

const propTypes = {
  auth: PropTypes.object.isRequired,
  fetchCertificate: PropTypes.func.isRequired
};

class Certificate extends Component {

    constructor (props) {
      super(props);
      this.state = {
          certificate: null,
          removals: null,
          errors: ''
      };
    }

    componentDidMount() {
        this.props.fetchCertificate()
            .then(data => this.setState({ 
                certificate: data.certificate,
                removals: data.removals
            }))
            .catch(error => {
                return Promise.reject(error)
            });
    }

    removalTypes() {

        let removalTypes = this.state.certificate.removal_types;
        let keysSorted = Object.keys(this.state.removals).sort(function(a,b){
            a = parseInt(a);
            b = parseInt(b);
            if(removalTypes.includes(a) && !removalTypes.includes(b)){
                return -1;
            }
            if(removalTypes.includes(b) && !removalTypes.includes(a)){
                return 1;
            }
            return a - b;
        });

        let rows = [];
        for(let i = 0; i < keysSorted.length; i++){
          let key = keysSorted[i];
          let value = this.state.removals[key];
          let enabled = removalTypes.includes(parseInt(key));
          
          rows.push(
            <div key={key} className={'md-certificate ' + (enabled ? '' : 'text-muted') }>
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="104.000000pt" height="62.000000pt" viewBox="0 0 104.000000 62.000000"
                preserveAspectRatio="xMidYMid meet" className='d-inline-block'
              >
                <g transform="translate(0.000000,62.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M313 601 c-3 -14 -15 -21 -37 -23 -27 -3 -31 -7 -34 -35 l-3 -33
                -114 0 c-73 0 -116 -4 -121 -11 -13 -21 21 -29 127 -29 98 0 107 -2 112 -20 4
                -15 14 -20 36 -20 26 0 31 -4 31 -24 0 -21 -6 -25 -32 -28 l-33 -3 0 -65 0
                -65 33 -3 c26 -3 32 -7 32 -28 0 -20 -5 -24 -31 -24 -22 0 -32 -5 -36 -20 -5
                -18 -14 -20 -112 -20 -106 0 -140 -8 -127 -29 5 -7 48 -11 121 -11 l114 0 3
                -32 c3 -29 7 -33 34 -36 22 -2 34 -9 37 -23 5 -18 13 -20 94 -17 88 3 88 3 91
                31 5 38 39 38 44 0 3 -28 3 -28 91 -31 81 -3 89 -1 94 17 3 14 15 21 37 23 27
                3 31 7 34 36 l3 32 114 0 c73 0 116 4 121 11 13 21 -21 29 -127 29 -98 0 -107
                2 -112 20 -4 15 -14 20 -36 20 -26 0 -31 4 -31 24 0 21 6 25 33 28 l32 3 0 65
                0 65 -32 3 c-27 3 -33 7 -33 28 0 20 5 24 31 24 22 0 32 5 36 20 5 18 14 20
                112 20 106 0 140 8 127 29 -5 7 -48 11 -121 11 l-114 0 -3 33 c-3 28 -7 32
                -34 35 -22 2 -34 9 -37 23 -5 18 -13 20 -94 17 -88 -3 -88 -3 -91 -30 -2 -20
                -9 -28 -22 -28 -13 0 -20 8 -22 28 -3 27 -3 27 -91 30 -81 3 -89 1 -94 -17z
                m152 -291 l0 -275 -57 -3 -58 -3 0 281 0 281 58 -3 57 -3 0 -275z m225 0 l0
                -281 -57 3 -58 3 -3 265 c-1 146 0 270 3 277 3 8 24 13 60 13 l55 0 0 -280z
                m-380 195 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15 35 10 0 15
                -11 15 -35z m450 0 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15
                35 10 0 15 -11 15 -35z m-220 -195 c0 -213 -1 -220 -20 -220 -19 0 -20 7 -20
                220 0 213 1 220 20 220 19 0 20 -7 20 -220z m-230 0 c0 -29 -4 -40 -15 -40
                -11 0 -15 11 -15 40 0 29 4 40 15 40 11 0 15 -11 15 -40z m450 0 c0 -29 -4
                -40 -15 -40 -11 0 -15 11 -15 40 0 29 4 40 15 40 11 0 15 -11 15 -40z m-450
                -195 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15 35 10 0 15 -11
                15 -35z m450 0 c0 -24 -5 -35 -15 -35 -10 0 -15 11 -15 35 0 24 5 35 15 35 10
                0 15 -11 15 -35z"/>
                </g>
              </svg>
              {/* <img src={window.App.baseUrl + 'assets/app/img/icon_pakkingen.png'} alt="Placeholder" className="d-inline-block" /> */}
              <div className="d-inline-block">
                  <strong>{value}</strong>
                  { enabled ? 
                    (
                        <span>
                            { __('app.profile.certified_until') + ' ' + this.state.certificate.certificate_valid_until }
                        </span>
                    ) : (
                        <span className="text-muted">{ __('app.profile.not_certified') }</span>
                    )
                  }
              </div>
            </div>
          );
        }
        
        return rows;
    }

    render () {
        return (
            <div className="md-box p-5">
                { this.props.auth.user && 
                    (
                    <h1 className="fw-600 mb-4">{ this.props.auth.user.name }</h1>
                    )
                }
                { this.state.certificate &&  
                    <React.Fragment>
                        <p className="m-0 font-size-18">{ __('app.profile.certificate_number') }</p>
                        <strong className="textdarkgreen d-block font-size-22">{ this.state.certificate.certificate_id }</strong>
                    </React.Fragment>
                }
                { this.state.removals &&  
                    <React.Fragment>
                        <p className="my-4 font-size-18">{ __('app.profile.certified_for') }</p>
                        <div className="md-certificates">
                            { this.removalTypes() }
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

Certificate.propTypes = propTypes;

const mapDispatchToProps = {
  fetchCertificate
};

export default connect(null, mapDispatchToProps)(withRouter(Certificate));